import { SUPPORTED_LANGS } from "@majourneys/shared";

/**
 * Name of the body <meta> emitted by `SsrLangMarker` (app-root.tsx). Its
 * content is the language the i18n provider actually rendered with — the
 * Worker compares it to the path locale before edge-caching a response, so a
 * wrong-language render (e.g. a regression of the i18n singleton race) can
 * be served once but never frozen into the public cache.
 */
export const SSR_LANG_META_NAME = "ssr-lang";

const MARKER_RE = new RegExp(
  `<meta[^>]*name="${SSR_LANG_META_NAME}"[^>]*content="([a-z]{2})"`,
);

/** Lang the i18n provider actually rendered with (from the body marker). */
export function extractSsrLang(html: string): string | null {
  return MARKER_RE.exec(html)?.[1] ?? null;
}

/** Locale prefix of a pathname, or null when the path is not localized. */
export function pathLocale(pathname: string): string | null {
  const first = pathname.split("/").filter(Boolean)[0] ?? "";
  return (SUPPORTED_LANGS as readonly string[]).includes(first) ? first : null;
}
